import { Language } from '../entities/company-admin-structure';
import { Category } from '../entities/category';

export const getPhotoCategories = (languages: Language[], languageId?: number): Category[] => {
  if (typeof languageId === 'undefined') {
    return [];
  }

  const language = languages.find((item) => item.id === languageId);

  if (!language) {
    return [];
  }

  return language.photoCategories || language.categories || [];
};
